// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__1crIz","spinner":"loader_spinner__1RtIs","spin":"loader_spin__sUQMw"};